/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import {
  InputField, Label, MultiSelectField
} from "components/Form";
import { Col, Row } from "components/Grid";
import { Field, Form, Formik } from "formik";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  CalendarContainer, CheckBoxColumn, DialogCancel,
  DialogConfirm,
  DialogSelect, FilterColumn, FilterSearchContainer, MobileLabel, RowFilter
} from "./styles";

import { DateRangePicker } from "components";
import DialogComponent from "components/Dialog/index";
import Checkbox from "components/Form/CheckBox";
import { Button } from "components/index";
import { GlobalAuthContext } from "store/context";
import * as Yup from 'yup';


const CustomFilterModal = (props) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const formik = useRef(null);
  const authContext = useContext(GlobalAuthContext);
  const isClient = authContext.enumProfile === 1 ? true : false;

  const [typeDialog, setTypeDialog] = useState(null);
  const [args, setArgs] = useState({});
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });

  const initialValues = {
    nmClient: "",
    orderClient: 0,
    nmObligor: "",
    orderObligor: 0,
    idBroker: "",
    orderBroker: 0,
    idStatus: "",
    orderStatus: 0,
    dtResponseBy: {
      from: null,
      to: null,
    },
    orderResponseBy: 0,
    dsReferenceNumber: "",
    leadingOffice: "",
    orderReferenceNumber: 0,
    idAction: "",
    orderOffice: 0,
    hideInactiveTransactions: false,
    hideExecutedTransactions: false
  };

  const [showCustomFilter, setShowCustomFilter] = useState(true);

  useEffect(() => {
    props.props.formikRef(formik);
  }, []);

  const showRangeDate = () => {
    const from = formik.current?.values?.dtResponseBy?.from
      ? formik.current.values.dtResponseBy.from.toLocaleDateString("en-GB")
      : "";
    const to = formik.current?.values?.dtResponseBy?.to
      ? formik.current.values.dtResponseBy.to.toLocaleDateString("en-GB")
      : "";

    if (!from && !to) {
      return "";
    }

    return `${from} - ${to}`;
  };

  const actionOptions = [
    { label: "To Assign", value: 1 },
    { label: "To Approve", value: 2 },
  ];

  return (
    <Formik
      onSubmit={(values) => {
        props.props.updateFilter(values);
      }}
      initialValues={initialValues}
      innerRef={formik}
      enableReinitialization={true}
    >
      {(formikProps) => {
        return (
          <Form>
            <FilterSearchContainer>
              <Row>
                <Col>
                  <MobileLabel>FILTER</MobileLabel>
                </Col>
                <Col>
                  <Button
                    primary
                    type="button"
                    id="btnFilter"
                    style={{ textAlign: "center" }}
                    onClick={(e) => {
                      setTypeDialog('createFilter');
                      setDialog({
                        visible: true,
                        title: 'Create Filter',
                        icon: 'exclamation',
                        args: null
                      })
                      setArgs(formikProps.values)
                    }}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
              {isClient
                ? <></>
                : (
                  <RowFilter>
                    <CheckBoxColumn>
                      <Label>
                        <Checkbox
                          checked={formikProps.values.nmClient.length}
                          onChange={() =>
                            formik.current?.setFieldValue("nmClient", "")
                          }
                        />
                      </Label>
                    </CheckBoxColumn>
                    <FilterColumn>
                      <Field
                        name="nmClient"
                        placeholder="Client"
                        value={formikProps.values.nmClient}
                        component={InputField}
                        type="text"
                        onChange={(e) => {
                          formikProps?.setFieldValue("nmClient", e);
                        }}
                        validation={false}
                        list={true}
                        onPressEnter={() => {
                          formikProps.submitForm();
                        }}
                      />
                    </FilterColumn>
                  </RowFilter>
                )}
              <RowFilter>
                <CheckBoxColumn>
                  <Label>
                    <Checkbox
                      checked={formikProps.values.nmObligor.length}
                      onChange={() =>
                        formik.current?.setFieldValue("nmObligor", "")
                      }
                    />
                  </Label>
                </CheckBoxColumn>
                <FilterColumn>
                  <Field
                    name="nmObligor"
                    placeholder="Main Party"
                    component={InputField}
                    type="text"
                    validation={false}
                    value={formikProps.values.nmObligor}
                    onChange={(e) => {
                      formikProps?.setFieldValue("nmObligor", e);
                    }}
                    list={true}
                    onPressEnter={() => {
                      formikProps.submitForm();
                    }}
                  />
                </FilterColumn>
              </RowFilter>

              <RowFilter>
                <CheckBoxColumn>
                  <Label>
                    <Checkbox
                      checked={formikProps.values.idBroker}
                      onChange={() =>
                        formik.current?.setFieldValue("idBroker", "")
                      }
                    />
                  </Label>
                </CheckBoxColumn>
                <FilterColumn>
                  <Field
                    name="idBroker"
                    placeholder="Broker"
                    type="text"
                    component={MultiSelectField}
                    options={props.props.broker || []}
                    validation={false}
                    value={formikProps.values.idBroker}
                    onChange={(e) => {
                      formikProps?.setFieldValue("idBroker", e);
                    }}
                    format={(value) => {
                      const selectedBrokers = props.props.broker.filter(option => value.includes(option.value))
                      return selectedBrokers.map(item => item.label).join(', ')
                    }}
                    filter={true}
                  />
                </FilterColumn>
              </RowFilter>

              <RowFilter>
                <CheckBoxColumn>
                  <Label>
                    <Checkbox
                      checked={formikProps.values.idStatus}
                      onChange={() =>
                        formik.current?.setFieldValue("idStatus", "")
                      }
                    />
                  </Label>
                </CheckBoxColumn>
                <FilterColumn>
                  <Field
                    name="idStatus"
                    placeholder="Status"
                    component={MultiSelectField}
                    options={props.props.status || []}
                    validation={false}
                    value={formikProps.values.idStatus}
                    filter={true}
                    onChange={(e) => {
                      formikProps?.setFieldValue("idStatus", e);
                    }}
                    format={(value) => {
                      const selectedStatus = props.props.status.filter(option => value.includes(option.value))
                      return selectedStatus.map(item => item.label).join(', ')
                    }}
                    corDiferente={false}
                  />
                </FilterColumn>
              </RowFilter>

              <RowFilter>
                <CheckBoxColumn>
                  <Label>
                    <Checkbox
                      checked={formikProps.values.dtResponseBy.from}
                      onChange={() =>
                        formik.current?.setFieldValue("dtResponseBy", {
                          from: null,
                          to: null,
                        })
                      }
                    />
                  </Label>
                </CheckBoxColumn>
                <FilterColumn>
                  <Field
                    name="dtResponseBy"
                    placeholder="Create Date"
                    component={InputField}
                    rightIcon="calendar"
                    rightIconClick={() => {
                      setShowCalendar(!showCalendar);
                    }}
                    validation={false}
                    customValue={showRangeDate()}
                    type="text"
                    readOnly
                  />
                </FilterColumn>
              </RowFilter>

              {showCalendar && (
                <CalendarContainer>
                  <DateRangePicker
                    initialRange={{
                      from: formikProps.values?.dtResponseBy?.from,
                      to: formikProps.values?.dtResponseBy?.to,
                    }}
                    onChange={(range) => {
                      formikProps?.setFieldValue(
                        "dtResponseBy.from",
                        range.from
                      );
                      formikProps?.setFieldValue(
                        "dtResponseBy.to",
                        range.to
                      );

                      if (range.from && range.to) {
                        setShowCalendar(false);
                        props.props.updateFilter({
                          dtResponseByFrom: new Date(
                            range.from
                          ).toLocaleDateString("en-US"),
                          dtResponseByTo: new Date(
                            range.to
                          ).toLocaleDateString("en-US"),
                        });
                      }
                    }}
                  />
                </CalendarContainer>
              )}

              <RowFilter>
                <CheckBoxColumn>
                  <Label>
                    <Checkbox
                      checked={formikProps.values.dsReferenceNumber.length}
                      onChange={() =>
                        formik.current?.setFieldValue(
                          "dsReferenceNumber",
                          ""
                        )
                      }
                    />
                  </Label>
                </CheckBoxColumn>
                <FilterColumn>
                  <Field
                    name="dsReferenceNumber"
                    placeholder="Reference Number"
                    component={InputField}
                    type="text"
                    validation={false}
                    value={formikProps.values.dsReferenceNumber}
                    onChange={formikProps.handleChange}
                    filter={true}
                    onPressEnter={() => {
                      formikProps.submitForm();
                    }}
                  />
                </FilterColumn>
              </RowFilter>

              <RowFilter>
                <CheckBoxColumn>
                  <Label>
                    <Checkbox
                      checked={formikProps.values.leadingOffice.length}
                      onChange={() =>
                        formik.current?.setFieldValue(
                          "leadingOffice",
                          ""
                        )
                      }
                    />
                  </Label>
                </CheckBoxColumn>
                <FilterColumn>
                  <Field
                    name="leadingOffice"
                    placeholder="Leading Office"
                    component={InputField}
                    type="text"
                    validation={false}
                    value={formikProps.values.leadingOffice}
                    onChange={formikProps.handleChange}
                    filter={true}
                    onPressEnter={() => {
                      formikProps.submitForm();
                    }}
                  />
                </FilterColumn>
              </RowFilter>


              {isClient ? (
                <></>
              ) : (
                <RowFilter>
                  <CheckBoxColumn>
                    <Label>
                      <Checkbox
                        checked={formikProps.values.idAction}
                        onChange={() =>
                          formik.current?.setFieldValue("idAction", "")
                        }
                      />
                    </Label>
                  </CheckBoxColumn>
                  <FilterColumn>
                    <Field
                      name="idAction"
                      placeholder="Actions"
                      component={MultiSelectField}
                      options={actionOptions}
                      validation={false}
                      value={formikProps.values.idAction}
                      filter={true}
                      onChange={(e) => {
                        formikProps?.setFieldValue("idAction", e);
                      }}
                      corDiferente={false}
                      format={(value) => {
                        const selectedActions = actionOptions.filter(option => value.includes(option.value))
                        return selectedActions.map(item => item.label).join(', ')
                      }}
                    />
                  </FilterColumn>
                </RowFilter>
              )}

              <RowFilter>
                <CheckBoxColumn>
                  <Label>
                    <Checkbox
                      checked={formikProps.values.hideInactiveTransactions}
                      onChange={() =>
                        formik.current?.setFieldValue("hideInactiveTransactions", !formikProps.values.hideInactiveTransactions)
                      }
                    />
                  </Label>
                </CheckBoxColumn>
                <Label fontSize={14}>
                  Hide Inactive Transactions
                </Label>
              </RowFilter>

              <RowFilter>
                <CheckBoxColumn>
                  <Label>
                    <Checkbox
                      checked={formikProps.values.hideExecutedTransactions}
                      onChange={() => formik.current?.setFieldValue('hideExecutedTransactions', !formikProps.values.hideExecutedTransactions)}
                    />
                  </Label>
                </CheckBoxColumn>
                <FilterColumn style={{ paddingLeft: "10px" }}>
                  <Label fontSize={14}>Hide Executed Transactions</Label>
                </FilterColumn>
              </RowFilter>

            </FilterSearchContainer>

            <Row
              align="center"
              className="apply-button-container"
            >
              <Col>
                <Button
                  primary
                  type="button"
                  id="btnFilter"
                  style={{ textAlign: "center" }}
                  onClick={(e) => {
                    setShowCustomFilter(false);
                    formikProps.submitForm();
                  }}
                >
                  Apply
                </Button>
              </Col>
            </Row>

            <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
              {typeDialog == 'createFilter' &&
                <Formik
                  initialValues={{ filters: '' }}
                  validationSchema={Yup.object().shape({ filters: Yup.string().required("* Required field") })}
                  onSubmit={route => {
                    console.log(route)
                    console.log(args)
                    setDialog({ visible: false, title: null, icon: null, args: null })
                  }}
                  render={({ values, setFieldValue }) => (
                    <Form>
                      <DialogSelect>
                        <Field
                          name="Filter name"
                          value={values.filters}
                          onChange={e => { setFieldValue('filters', e) }}
                          placeholder="My Tasks"
                          component={InputField}
                        />
                      </DialogSelect>
                      <DialogCancel onClick={(e) => { e.stopPropagation(); e.preventDefault(); setShowCustomFilter(true); setDialog({ visible: false, title: null, icon: null, args: null }) }}>Cancel</DialogCancel>
                      <DialogConfirm type="submit">Confirm</DialogConfirm>
                    </Form>
                  )}>
                </Formik>}
            </DialogComponent>

          </Form>
        );
      }}
    </Formik>
  );
};

export default CustomFilterModal;
